function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isThenable } from './is.js';

/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States;
(function (States) {
  /** Pending */
  var PENDING = 0;
  States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  var RESOLVED = 1;
  States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  var REJECTED = 2;
  States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(function (resolve) {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise(function (_, reject) {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /*#__PURE__*/function () {
  function SyncPromise(executor) {
    _classCallCheck(this, SyncPromise);
    SyncPromise.prototype.__init.call(this);
    SyncPromise.prototype.__init2.call(this);
    SyncPromise.prototype.__init3.call(this);
    SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
  _createClass(SyncPromise, [{
    key: "then",
    value: function then(onfulfilled, onrejected) {
      var _this = this;
      return new SyncPromise(function (resolve, reject) {
        _this._handlers.push([false, function (result) {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result);
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        }, function (reason) {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        }]);
        _this._executeHandlers();
      });
    } /** JSDoc */
  }, {
    key: "catch",
    value: function _catch(onrejected) {
      return this.then(function (val) {
        return val;
      }, onrejected);
    } /** JSDoc */
  }, {
    key: "finally",
    value: function _finally(onfinally) {
      var _this2 = this;
      return new SyncPromise(function (resolve, reject) {
        var val;
        var isRejected;
        return _this2.then(function (value) {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        }, function (reason) {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        }).then(function () {
          if (isRejected) {
            reject(val);
            return;
          }
          resolve(val);
        });
      });
    } /** JSDoc */
  }, {
    key: "__init",
    value: function __init() {
      var _this3 = this;
      this._resolve = function (value) {
        _this3._setResult(States.RESOLVED, value);
      };
    } /** JSDoc */
  }, {
    key: "__init2",
    value: function __init2() {
      var _this4 = this;
      this._reject = function (reason) {
        _this4._setResult(States.REJECTED, reason);
      };
    } /** JSDoc */
  }, {
    key: "__init3",
    value: function __init3() {
      var _this5 = this;
      this._setResult = function (state, value) {
        if (_this5._state !== States.PENDING) {
          return;
        }
        if (isThenable(value)) {
          void value.then(_this5._resolve, _this5._reject);
          return;
        }
        _this5._state = state;
        _this5._value = value;
        _this5._executeHandlers();
      };
    } /** JSDoc */
  }, {
    key: "__init4",
    value: function __init4() {
      var _this6 = this;
      this._executeHandlers = function () {
        if (_this6._state === States.PENDING) {
          return;
        }
        var cachedHandlers = _this6._handlers.slice();
        _this6._handlers = [];
        cachedHandlers.forEach(function (handler) {
          if (handler[0]) {
            return;
          }
          if (_this6._state === States.RESOLVED) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            handler[1](_this6._value);
          }
          if (_this6._state === States.REJECTED) {
            handler[2](_this6._value);
          }
          handler[0] = true;
        });
      };
    }
  }]);
  return SyncPromise;
}();
export { SyncPromise, rejectedSyncPromise, resolvedSyncPromise };